import * as React from "react";
import PropTypes from 'prop-types';

const SvgMothersDay = props => {
  if (props.id !== "_svgmothersday") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 144 144" {...props}><defs><circle id="mothers-day_svg__a" cx={72} cy={72} r={66} /></defs><g fill="none" fillRule="evenodd"><mask id="mothers-day_svg__b" fill="#fff"><use xlinkHref="#mothers-day_svg__a" /></mask><use fill="#C5EAF4" fillRule="nonzero" xlinkHref="#mothers-day_svg__a" /><path fill="#028B46" d="M66 100h12v38H66z" mask="url(#mothers-day_svg__b)" /><path fill="#C00" d="M99.924 87.912c6.64 12.842 7.227 25.395.843 29.541-6.936 4.504-19.589-2.542-28.93-15.832-9.092 13.273-21.496 20.408-28.46 16.056-6.546-4.09-6.077-16.95.601-30.098-14.953-1.445-26.29-8.128-26.153-15.948.138-7.93 12.028-14.28 27.332-15.062-7.38-13.348-8.268-26.722-1.638-31.028 6.863-4.457 19.324 2.396 28.636 15.418 9.064-13.01 21.283-19.952 28.175-15.646 6.79 4.242 6.033 17.916-1.37 31.562 15.475 1.225 27.352 8.037 27.213 16.04-.136 7.743-11.471 13.979-26.249 14.997z" mask="url(#mothers-day_svg__b)" /><circle cx={72} cy={72} r={20} fill="#EFB75C" mask="url(#mothers-day_svg__b)" /></g></svg>;
};

SvgMothersDay.displayName = "_svgmothersday";
SvgMothersDay.propTypes = {
  id: PropTypes.string
};
SvgMothersDay.defaultProps = {
  id: ''
};
export default SvgMothersDay;